import { Component } from '@angular/core';
import { PopoverController, NavController, Platform } from '@ionic/angular';

import { DialogConstant } from '../../Constant';

import { ApiService } from '../../service/api.service';
import { DialogService } from '../../service/dialog.service';

@Component({
    selector: 'app-setting-popover',
    templateUrl: './setting-popover.page.html',
    styleUrls: ['./setting-popover.page.scss'],
})
export class SettingPopoverPage
{
    private resize = null;

    constructor(
        private popover: PopoverController,
        private nav: NavController,
        private platform: Platform,
        private api: ApiService,
        private dialog: DialogService
    )
    {
    }

    async ngOnInit()
    {
        this.resize = this.platform.resize.subscribe(() => {
            this.popover.dismiss();
        });
    }

    ngOnDestroy()
    {
        if (this.resize == null) return;
        this.resize.unsubscribe();
        this.resize = null;
    }


    moveSetting()
    {
        this.popover.dismiss();
        this.nav.navigateRoot(`/profile`);
    }

    logout()
    {
        this.popover.dismiss();

        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: async() => {
                await this.api.logout();
            }
        };

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, DialogConstant.LOGOUT_CONFIRM, [btn1, btn2]);
    }
}
